import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/add_icon.svg'
import _imports_2 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "delete-all-btn-link" }
const _hoisted_17 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_18 = { class: "add-banner-image-section" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_22 = { class: "admin-input-field" }
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = { class: "admin-input-field" }
const _hoisted_25 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_26 = { class: "admin-input-field" }
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = { class: "admin-input-field" }
const _hoisted_29 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_30 = { class: "admin-custom-row box-row-2" }
const _hoisted_31 = { class: "admin-input-field" }
const _hoisted_32 = { class: "image-upload-input upload-banner-image" }
const _hoisted_33 = { class: "file-input-box" }
const _hoisted_34 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_35 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_38 = { class: "admin-input-field" }
const _hoisted_39 = { class: "image-upload-input upload-banner-image" }
const _hoisted_40 = { class: "file-input-box" }
const _hoisted_41 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_42 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_45 = { class: "admin-input-field-submit" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_48 = { class: "admin-item-list-section-scroll" }
const _hoisted_49 = { class: "admin-item-list-top" }
const _hoisted_50 = { class: "admin-item-list-row" }
const _hoisted_51 = { class: "admin-item-checkbox" }
const _hoisted_52 = { class: "admin-checkbox-input" }
const _hoisted_53 = ["checked"]
const _hoisted_54 = { class: "admin-item-banner-image" }
const _hoisted_55 = { class: "admin-item-client-logo" }
const _hoisted_56 = { class: "admin-item-actions" }
const _hoisted_57 = { class: "admin-item-list-btm" }
const _hoisted_58 = { ref: "sortableList" }
const _hoisted_59 = { class: "admin-item-box-top" }
const _hoisted_60 = { class: "admin-item-list-row" }
const _hoisted_61 = { class: "admin-item-checkbox" }
const _hoisted_62 = { class: "admin-checkbox-input" }
const _hoisted_63 = ["id", "onChange", "checked"]
const _hoisted_64 = ["for"]
const _hoisted_65 = { class: "admin-item-client-title text-limit" }
const _hoisted_66 = { class: "admin-item-client-desc text-limit" }
const _hoisted_67 = { class: "admin-item-client-Challenge text-limit" }
const _hoisted_68 = { class: "admin-item-client-Solution text-limit" }
const _hoisted_69 = { class: "admin-item-banner-image" }
const _hoisted_70 = { class: "admin-item-banner-image-box" }
const _hoisted_71 = ["src"]
const _hoisted_72 = { class: "admin-item-client-logo" }
const _hoisted_73 = { class: "dmin-item-client-logo-box" }
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "admin-item-actions" }
const _hoisted_76 = { class: "admin-action-link" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_82 = { class: "add-banner-image-section" }
const _hoisted_83 = { class: "add-banner-image-box" }
const _hoisted_84 = { class: "admin-input-field" }
const _hoisted_85 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_86 = { class: "admin-input-field" }
const _hoisted_87 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_88 = { class: "admin-input-field" }
const _hoisted_89 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_90 = { class: "admin-input-field" }
const _hoisted_91 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_92 = { class: "admin-input-field" }
const _hoisted_93 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_94 = { class: "admin-custom-row box-row-2" }
const _hoisted_95 = { class: "admin-input-field" }
const _hoisted_96 = { class: "image-upload-input upload-banner-image" }
const _hoisted_97 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_98 = { class: "file-input-box" }
const _hoisted_99 = { class: "image-upload-input-item-uploaded" }
const _hoisted_100 = ["src"]
const _hoisted_101 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_102 = { class: "admin-input-field" }
const _hoisted_103 = { class: "image-upload-input upload-banner-image" }
const _hoisted_104 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_105 = { class: "file-input-box" }
const _hoisted_106 = { class: "image-upload-input-item-uploaded" }
const _hoisted_107 = ["src"]
const _hoisted_108 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_109 = { class: "admin-input-field-submit" }
const _hoisted_110 = ["onClick", "disabled"]
const _hoisted_111 = { class: "admin-pagination-section" }
const _hoisted_112 = { class: "custom-row" }
const _hoisted_113 = { class: "item-show-selectbox" }
const _hoisted_114 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_115 = ["onClick"]
const _hoisted_116 = { key: 2 }
const _hoisted_117 = { class: "admin-site-footer" }
const _hoisted_118 = { class: "container" }
const _hoisted_119 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_120 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_121 = { class: "modal-content" }
const _hoisted_122 = { class: "confirmation-popup-mid" }
const _hoisted_123 = { class: "confirmation-popup-btm" }
const _hoisted_124 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_CLIENTS_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "searchClientInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchClients(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addClientBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddForm = true, _ctx.selectedClients = [], _ctx.selectAll = false, _ctx.cancelEdit()))
                      }, [
                        _cache[39] || (_cache[39] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_CLIENT_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedClients.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedClients.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedClients = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_CLIENT_TEXT), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("form", {
                        id: "addClientsForm",
                        onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "clientTitleInput",
                            type: "text",
                            placeholder: "Enter the Title",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newClient.title) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newClient.title]
                          ]),
                          (!_ctx.newClient.title && _ctx.errMsg)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Description",
                            class: "text-editer",
                            id: "clientDescriptionInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newClient.description,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newClient.description) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newClient.description && _ctx.errMsg)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.CHALLENGE_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Challenge",
                            class: "text-editer",
                            id: "clientChallengeInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newClient.challenge,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newClient.challenge) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newClient.challenge && _ctx.errMsg)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SOLUTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Solution",
                            class: "text-editer",
                            id: "clientSolutionInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newClient.solution,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newClient.solution) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newClient.solution && _ctx.errMsg)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.RESULT_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Result",
                            class: "text-editer",
                            id: "clientResultInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newClient.result,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newClient.result) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newClient.result && _ctx.errMsg)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", {
                                class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("button", {
                                    class: "image-upload-input-item-delete-btn",
                                    id: "uploaded-img-delete-btn",
                                    type: "button",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearUploadedImage(false, 'client-image')))
                                  }),
                                  _createElementVNode("input", {
                                    id: "addClientFileInput",
                                    type: "file",
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                    accept: "image/jpeg,image/jpg,image/png"
                                  }, null, 32)
                                ]),
                                (!_ctx.imageUploaded)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                        _createElementVNode("img", {
                                          src: _imports_0,
                                          alt: ""
                                        })
                                      ], -1)),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_IMAGE_LABEL), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.imageUploaded)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _createElementVNode("img", {
                                        src: _ctx.imageUrl,
                                        alt: "",
                                        class: "mCS_img_loaded"
                                      }, null, 8, _hoisted_36)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            (!_ctx.selectedFile && _ctx.errMsg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.errMsg), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.LOGO_LABEL), 1),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", {
                                class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.logoUploaded }])
                              }, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("button", {
                                    class: "image-upload-input-item-delete-btn",
                                    id: "uploaded-img-delete-btn",
                                    type: "button",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearUploadedImage(false, 'client-logo')))
                                  }),
                                  _createElementVNode("input", {
                                    id: "addClientLogoFileInput",
                                    type: "file",
                                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleLogoUpload($event, false))),
                                    accept: "image/jpeg,image/jpg,image/png"
                                  }, null, 32)
                                ]),
                                (!_ctx.logoUploaded)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                        _createElementVNode("img", {
                                          src: _imports_1,
                                          alt: ""
                                        })
                                      ], -1)),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_LOGO_LABEL), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.logoUploaded)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _createElementVNode("img", {
                                        src: _ctx.logoUrl,
                                        alt: "",
                                        class: "mCS_img_loaded"
                                      }, null, 8, _hoisted_43)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            (!_ctx.selectedLogoFile && _ctx.errMsg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.errMsg), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("button", {
                            id: "clientSubmitBtn",
                            class: "admin-btn-outline-primary add-new-cancel",
                            type: "submit",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_46),
                          _createElementVNode("button", {
                            id: "clientCancleBtn",
                            class: "admin-btn-outline-secondary add-new-cancel",
                            type: "button",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editClientsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section admin-client-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_53),
                              _cache[42] || (_cache[42] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-client-title",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-client-desc",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleSort('description'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESCRIPTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'description' || _ctx.sortBy === '-description')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-description' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-client-Challenge",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleSort('challenge'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.CHALLENGE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'challenge' || _ctx.sortBy === '-challenge')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-challenge' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-client-Solution",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleSort('solution'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.SOLUTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'solution' || _ctx.sortBy === '-solution')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-solution' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.constants.LOGO_LABEL), 1),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1),
                          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editClientsData, (client, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: client.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': client.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("div", _hoisted_62, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + client.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleClientSelection(client.slug)),
                                        checked: _ctx.selectedClients.includes(client.slug)
                                      }, null, 40, _hoisted_63),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + client.id
                                      }, null, 8, _hoisted_64)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_65, _toDisplayString(client.title), 1),
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.useStripHtml(client.description)), 1),
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.useStripHtml(client.challenge)), 1),
                                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.useStripHtml(client.solution)), 1),
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(client.companyImage, `w_85,h_42/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg',
                                        alt: ""
                                      }, null, 8, _hoisted_71)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(client.companyLogo, `w_140,h_38/`) || '@/assets/images/admin-img/demo-img/demo-icon-1.png',
                                        alt: ""
                                      }, null, 8, _hoisted_74)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("ul", _hoisted_76, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "clientPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editClient(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_77)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "clientPgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', client.slug), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_78)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (client.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "clientPgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeClientStatus(client.slug, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_79))
                                          : (client.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "clientPgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeClientStatus(client.slug, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_80))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "clear" }, null, -1))
                                ])
                              ]),
                              (client.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_CLIENT_TEXT), 1),
                                      _createElementVNode("div", _hoisted_83, [
                                        _createElementVNode("div", _hoisted_84, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "clientTitleInput",
                                            type: "text",
                                            placeholder: "Enter the Title",
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editClientData.title) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editClientData.title]
                                          ]),
                                          (!_ctx.editClientData.title && _ctx.errEditMsg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            class: "text-editer",
                                            id: "clientDescriptionInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editClientData.description,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editClientData.description) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editClientData.description && _ctx.errEditMsg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_88, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.CHALLENGE_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Challenge",
                                            class: "text-editer",
                                            id: "clientChallengeInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editClientData.challenge,
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editClientData.challenge) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editClientData.challenge && _ctx.errEditMsg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_90, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SOLUTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Solution",
                                            class: "text-editer",
                                            id: "clientSolutionInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editClientData.solution,
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editClientData.solution) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editClientData.solution && _ctx.errEditMsg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_92, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.RESULT_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Result",
                                            class: "text-editer",
                                            id: "clientResultInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editClientData.result,
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editClientData.result) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editClientData.result && _ctx.errEditMsg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_94, [
                                          _createElementVNode("div", _hoisted_95, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                                            _createElementVNode("div", _hoisted_96, [
                                              _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("div", _hoisted_98, [
                                                  _createElementVNode("button", {
                                                    class: "image-upload-input-item-delete-btn",
                                                    id: "uploaded-img-delete-btn",
                                                    type: "button",
                                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.clearUploadedImage(true, 'client-image')))
                                                  }),
                                                  _createElementVNode("input", {
                                                    id: "editClientFileInput",
                                                    type: "file",
                                                    onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                    accept: "image/jpeg,image/jpg,image/png"
                                                  }, null, 32)
                                                ]),
                                                _createElementVNode("div", _hoisted_99, [
                                                  _createElementVNode("img", {
                                                    src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                    alt: ""
                                                  }, null, 8, _hoisted_100)
                                                ])
                                              ])
                                            ]),
                                            (!_ctx.editimageSrc && !_ctx.selectedEditFile)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.errEditMsg), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_102, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.LOGO_LABEL), 1),
                                            _createElementVNode("div", _hoisted_103, [
                                              _createElementVNode("div", _hoisted_104, [
                                                _createElementVNode("div", _hoisted_105, [
                                                  _createElementVNode("button", {
                                                    class: "image-upload-input-item-delete-btn",
                                                    id: "uploaded-img-delete-btn",
                                                    type: "button",
                                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.clearUploadedImage(true, 'client-logo')))
                                                  }),
                                                  _createElementVNode("input", {
                                                    id: "editClientLogoFileInput",
                                                    type: "file",
                                                    onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleLogoUpload($event, true))),
                                                    accept: "image/jpeg,image/jpg,image/png"
                                                  }, null, 32)
                                                ]),
                                                _createElementVNode("div", _hoisted_106, [
                                                  _createElementVNode("img", {
                                                    src: _ctx.editLogoSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                    alt: ""
                                                  }, null, 8, _hoisted_107)
                                                ])
                                              ])
                                            ]),
                                            (!_ctx.editLogoSrc && !_ctx.selectedEditLogoFile)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_ctx.errEditMsg), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_109, [
                                          _createElementVNode("button", {
                                            id: "clientSubmitBtn",
                                            class: "admin-btn-outline-primary",
                                            onClick: ($event: any) => (_ctx.submitEditForm(client.slug)),
                                            disabled: _ctx.isSubmitting
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_110),
                                          _createElementVNode("button", {
                                            id: "clientCancleBtn",
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[45] || (_cache[45] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[46] || (_cache[46] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_115))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[47] || (_cache[47] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_116, [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_117, [
      _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_119, [
      _createElementVNode("div", _hoisted_120, [
        _createElementVNode("div", _hoisted_121, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("button", _hoisted_124, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}